module.exports = __webpack_public_path__ + "static/media/underage-logo-popover.11b918e0.svg";